import { AfterViewChecked, Component, ElementRef, HostListener, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { filter, take } from 'rxjs/operators';
import { ClientConsultService } from 'src/app/services/client-consult.service';
import { LoggerService } from 'src/app/services/logger/logger.service';
import { ConsultantStatus } from 'src/app/services/rest-api/rest-api';
import { UserService } from 'src/app/services/user/user.service';
import tippy, { Instance } from 'tippy.js';

// fixme - when tooltip is near screen edge it overflow is not visible
@Component({
  selector: 'libero-tooltip-button',
  templateUrl: './tooltip-button.component.html',
  styleUrls: ['./tooltip-button.component.scss'],
  standalone: false
})
export class TooltipButtonComponent implements OnInit, OnDestroy, AfterViewChecked {
  @Input() public whiteStyling = false;
  @Input() public explainPerson: 'jiri_mikes' | 'ondrej_peska' | 'marketa_nemcova' | 'jiri_sindelar' | 'monika_skodova' = 'ondrej_peska';
  @Input() public hidePerson = false;

  @HostListener('window:scroll')
  private onScroll() {
    if (this.tippyInstance && this.tippyInstance.state.isVisible) {
      this.tippyInstance.hide();
    }
  }

  public get displayTooltipContent(): boolean {
    return this.clientConsultService.clientConsult.status !== this.consultStatus.BLANK;
  }

  public get displayConsultImage(): boolean | null {
    return this.clientConsultService.clientConsult &&
    this.clientConsultService.clientConsult.value &&
    this.clientConsultService.clientConsult.status !== this.consultStatus.NOT_FOUND &&
    this.clientConsultService.clientConsultImage &&
    this.clientConsultService.clientConsultImage.value &&
    this.clientConsultService.clientConsultImage.status !== this.consultStatus.NOT_FOUND;
  }

  public mobileVisible = false;
  public consultStatus = ConsultantStatus;
  public displayTooltip = false;

  private tippyInstance: null | Instance  = null;

  public constructor(
    public clientConsultService: ClientConsultService,
    private loggerService: LoggerService,
    public userService: UserService,
  ) { }

  public ngAfterViewChecked(): void {
    if(this.displayTooltip && !this.tippyInstance) {
      this.bindTooltip();
    }
  }

  @ViewChild('triggerButton', { static: false }) private triggerButton?: ElementRef;
  @ViewChild('popoverContent', { static: false }) private popoverContent?: ElementRef;

  public ngOnInit(): void {
    this.clientConsultService.preloader$.pipe(
          filter(value => !value),
          take(1),
      ).subscribe(() => {
        this.displayTooltip = true;
    });
  }

  private bindTooltip(): void {
    if(this.triggerButton &&
      this.triggerButton.nativeElement &&
      this.popoverContent &&
      this.popoverContent.nativeElement
    ) {
      this.destroyTooltipInstance();

      this.tippyInstance = tippy(this.triggerButton.nativeElement, {
        content: this.popoverContent.nativeElement.innerHTML,
        allowHTML: true,
        placement: 'auto',
        popperOptions: {
          modifiers: [
            {
              name: 'preventOverflow',
              options: {
                altAxis: true,
              },
            },
          ],
        }
      }) as unknown as Instance; // never return array if input is single Element
    }
  }

  public ngOnDestroy(): void {
    window.removeEventListener('scroll', this.onScroll);
    this.destroyTooltipInstance();
  }

  private destroyTooltipInstance(): void {
    if(this.tippyInstance) {
      try {
        this.tippyInstance.destroy();
        this.tippyInstance = null;
      } catch (error) {
        this.loggerService.error(error);
      }
    }
  }
}
